import axios from "axios";

// Attach the logged-in session to every backend call (the server rejects unauthenticated /api requests).
const BACKEND = process.env.REACT_APP_BACKEND_URL;

const sessionToken = () => {
  const p = window.location.pathname;
  if (p.startsWith("/outlook-addin-finance") || p.startsWith("/finance-addin")) return localStorage.getItem("outlook_finance_token") || localStorage.getItem("token");
  if (p.startsWith("/outlook-addin-sales")) return localStorage.getItem("outlook_sales_token") || localStorage.getItem("token");
  if (p.startsWith("/outlook-addin")) return localStorage.getItem("outlook_token") || localStorage.getItem("token");
  return localStorage.getItem("token") || localStorage.getItem("outlook_token") || localStorage.getItem("outlook_sales_token") || localStorage.getItem("outlook_finance_token");
};

const isBackend = (url) => typeof url === "string" && (url.startsWith(BACKEND) || url.startsWith("/api/"));

const extraHeaders = (url, has) => {
  const out = {};
  if (!has("authorization")) {
    const t = sessionToken();
    if (t) out.Authorization = `Bearer ${t}`;
  }
  const wms = localStorage.getItem("wms_token");
  if (wms && url.includes("/api/wms/") && !has("x-wms-token")) out["X-WMS-Token"] = wms;
  return out;
};

export const installAuthHeaders = () => {
  axios.interceptors.request.use((config) => {
    const url = config.url || "";
    if (!isBackend(url)) return config;
    const current = config.headers || {};
    const has = (k) => Object.keys(typeof current.toJSON === "function" ? current.toJSON() : current).some((h) => h.toLowerCase() === k);
    const add = extraHeaders(url, has);
    Object.entries(add).forEach(([k, v]) => {
      if (typeof current.set === "function") current.set(k, v);
      else current[k] = v;
    });
    config.headers = current;
    return config;
  });

  const origFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = typeof input === "string" ? input : input?.url;
    if (!isBackend(url)) return origFetch(input, init);
    const headers = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined) || {});
    const add = extraHeaders(url, (k) => headers.has(k));
    Object.entries(add).forEach(([k, v]) => headers.set(k, v));
    return origFetch(input, { ...init, headers });
  };
};
